import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Alert from '../utils/Alert';
import Contain from '../components/app/Contain';
import VerifyEmail from '../components/auth/VerifyEmail';

function VerifyEmailView() {
  const { token } = useParams();
  const emailAddress = useSelector(
      (state) => state.session && state.session.EmailAddress,
  );

  return (
      <Contain maxWidth={600} fillHeight>
        <div style={{ margin: '4rem 0' }}>
          {!token ? (
              <Alert>
                Invalid verification link, please refer to your email for instructions.
              </Alert>
          ) : (
              <VerifyEmail token={token} emailAddress={emailAddress} />
          )}
        </div>
      </Contain>
  );
}

export default VerifyEmailView;
